import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // TODO: Issue MRP-2768
  // eslint-disable-next-line unicorn/no-null
  return null;
}

export default ScrollToTop;